import { IdentifierStatus } from '../enums/identifier-status.enum';
import { InvitationStatus } from '../enums/invitation-status.enum';

export const INVITATION_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.invitation.v1+json';

export class Invitation {
  public id: string;
  public status: InvitationStatus;
  public personalPhone: string;
  public personalEmail: string;
  public corporateEmail: string;
  public corporateEmailStatus: IdentifierStatus;
  public lineManagerEmail: string;
  public creationDate: Date;

  constructor(backEndInvitation?: BackEndInvitation) {
    if (backEndInvitation) {
      this.id = backEndInvitation.id;
      this.status = backEndInvitation.status;
      this.personalPhone = backEndInvitation.personal_phone_number;
      this.personalEmail = backEndInvitation.personal_email;
      this.corporateEmail = backEndInvitation.corporate_email;
      this.corporateEmailStatus = backEndInvitation.corporate_email_status;
      this.lineManagerEmail = backEndInvitation.line_manager_email;
      this.creationDate = backEndInvitation.created_at ? new Date(backEndInvitation.created_at) : null;
    }
  }

  public toBackend(): BackEndInvitation {
    return {
      id: this.id,
      status: this.status,
      personal_phone_number: this.personalPhone,
      personal_email: this.personalEmail,
      corporate_email: this.corporateEmail,
      corporate_email_status: this.corporateEmailStatus,
      line_manager_email: this.lineManagerEmail,
      created_at: this.creationDate?.toString(),
    };
  }

  public canDelete(): boolean {
    return this.status === InvitationStatus.Open;
  }
}
export interface BackEndInvitation {
  id: string;

  status: InvitationStatus;

  /** personal phone number in e.164 format */
  personal_phone_number: string;

  /** personal email address */
  personal_email: string;

  /** corporate email address - must end in registered corporate domain */
  corporate_email: string;

  corporate_email_status: IdentifierStatus;

  /** line manager email address - must end in registered corporate domain and not match email address of the requesting admin */
  line_manager_email: string;

  created_at: string;
}
